(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/onboarding-handler/assets/onboarding-data.js') >= 0) return;  svs.modules.push('/components/accountservices/onboarding-handler/assets/onboarding-data.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';
const path = isServer ? require('path') : undefined;
const DOMAIN = 'customer_login';
const PROPERTY = 'extraParams';

const SESSION_METHOD = {
  SET: 'set',
  GET: 'get',
  REMOVE: 'remove'
};

const isLoggedIn = req => isServer ? req.userSession && req.userSession.hasRole(req.userSession.roles.PLAYER) : svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);

const checkAllParamsUndefined = extraParams => {
  let hasAllUndefinedExtraParams = true;
  for (const param of Object.values(extraParams)) {
    if (typeof param !== 'undefined') {
      hasAllUndefinedExtraParams = false;
      break;
    }
  }
  return hasAllUndefinedExtraParams;
};

const stringToBool = string => {
  var _string$toLowerCase;
  const lowString = string === null || string === void 0 || (_string$toLowerCase = string.toLowerCase) === null || _string$toLowerCase === void 0 ? void 0 : _string$toLowerCase.call(string);
  switch (lowString) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return undefined;
  }
};

const convertUndefined = parameter => {
  var _parameter$toLowerCas;
  return (parameter === null || parameter === void 0 || (_parameter$toLowerCas = parameter.toLowerCase) === null || _parameter$toLowerCas === void 0 ? void 0 : _parameter$toLowerCas.call(parameter)) === 'undefined' ? undefined : parameter;
};

const handleSessionDataClientsideAsync = _ref => {
  let {
    sessionMethod = SESSION_METHOD.GET,
    value,
    forceDeviceSessionCall = false
  } = _ref;
  return new Promise(resolve => {
    const isSet = sessionMethod === SESSION_METHOD.SET;
    const isGet = sessionMethod === SESSION_METHOD.GET;
    const isRemove = sessionMethod === SESSION_METHOD.REMOVE;
    const fnBase = !isLoggedIn() || forceDeviceSessionCall ? svs.core.deviceSession : svs.core.userSession;
    const fn = isSet ? fnBase.set : isGet ? fnBase.get : isRemove ? fnBase.remove : () => {};
    const promiseCallback = function () {
      for (var _len = arguments.length, callbackParams = new Array(_len), _key = 0; _key < _len; _key++) {
        callbackParams[_key] = arguments[_key];
      }
      const [first, second] = callbackParams;
      const isResultParamFirst = isGet && !isLoggedIn();
      const result = isResultParamFirst ? first : second;
      const err = isResultParamFirst ? second : first;
      if (err) {
        resolve();
      } else {
        result && resolve(result) || resolve();
      }
    };
    const params = !isLoggedIn() || forceDeviceSessionCall ? [PROPERTY, DOMAIN, promiseCallback] : ["".concat(DOMAIN, ".").concat(PROPERTY), promiseCallback];
    if (!isSet && !isGet && !isRemove) {
      resolve();
    }
    if (isSet) {
      params.splice(params.length - 1, 0, value);
    }
    fn.call(fnBase, ...params);
  });
};

const getExtraData = async req => {
  let extraParams;
  if (isServer) {
    extraParams = isLoggedIn(req) ? req.userSession.get("".concat(DOMAIN, ".").concat(PROPERTY)) : req.session["".concat(DOMAIN, ".").concat(PROPERTY)];
  } else {
    extraParams = await handleSessionDataClientsideAsync({
      sessionMethod: SESSION_METHOD.GET
    });
  }
  return extraParams;
};

const setExtraData = async _ref2 => {
  let {
    extraParams,
    req
  } = _ref2;
  if (isServer) {
    if (isLoggedIn(req)) {
      req.userSession.set("".concat(DOMAIN, ".").concat(PROPERTY), extraParams);
    } else {
      req.session["".concat(DOMAIN, ".").concat(PROPERTY)] = extraParams;
    }
  } else {
    extraParams = await handleSessionDataClientsideAsync({
      sessionMethod: SESSION_METHOD.SET,
      value: extraParams
    });
  }
  return extraParams;
};

const updateExtraData = async _ref3 => {
  let {
    newExtraData,
    req
  } = _ref3;
  let extraParams;

  extraParams = await getExtraData(req);
  extraParams = _objectSpread(_objectSpread({}, extraParams), newExtraData);
  await setExtraData({
    extraParams,
    req
  });
  return extraParams;
};

const clearExtraData = async req => {
  if (isServer) {
    if (isLoggedIn(req)) {
      req.userSession.remove("".concat(DOMAIN, ".").concat(PROPERTY));
    }
    req.session["".concat(DOMAIN, ".").concat(PROPERTY)] = undefined;
  } else {
    await handleSessionDataClientsideAsync({
      sessionMethod: SESSION_METHOD.REMOVE
    });
    if (isLoggedIn()) {
      await handleSessionDataClientsideAsync({
        sessionMethod: SESSION_METHOD.REMOVE,
        forceDeviceSessionCall: true
      });
    }
  }
};

const setupExtraData = async _ref4 => {
  let {
    extraData,
    forceDefault,
    req
  } = _ref4;
  const onboardingTheme = isServer ? require(path.join(__dirname, 'onboarding-theme.es6')) : svs.accountservices.onboardingHandler;
  let {
    amount,
    branding,
    forceShortOnboarding: isForceShortOnboarding,
    gift: isGift,
    isReactivatedCustomer,
    isRetailCustomer,
    product,
    subscription: isSubscription,
    team,
    ticketsorderhome: isTicketsOrderHome,
    validateticketonline: isValidateTicketOnline,
    weeks
  } = extraData;
  let extraParams;
  let theme;

  if (forceDefault) {
    await clearExtraData(req);
    theme = onboardingTheme.getTheme();
    extraParams = _objectSpread(_objectSpread({}, extraParams), {}, {
      theme
    });
  } else {
    var _weeks, _weeks$toLowerCase;

    isSubscription = stringToBool(isSubscription);
    isGift = stringToBool(isGift);
    isValidateTicketOnline = stringToBool(isValidateTicketOnline);
    isTicketsOrderHome = stringToBool(isTicketsOrderHome);
    isForceShortOnboarding = stringToBool(isForceShortOnboarding);
    isRetailCustomer = stringToBool(isRetailCustomer);
    isReactivatedCustomer = stringToBool(isReactivatedCustomer);

    amount = convertUndefined(amount);
    product = convertUndefined(product);
    branding = convertUndefined(branding);
    team = convertUndefined(team);

    weeks = ((_weeks = weeks) === null || _weeks === void 0 || (_weeks$toLowerCase = _weeks.toLowerCase) === null || _weeks$toLowerCase === void 0 ? void 0 : _weeks$toLowerCase.call(_weeks)) !== 'undefined' && !isNaN(parseInt(weeks, 10)) ? parseInt(weeks, 10) : undefined;

    const isShortRegistrationFlow = isSubscription || isGift || isValidateTicketOnline || isForceShortOnboarding || isReactivatedCustomer;

    extraParams = {
      amount,
      branding,
      forceShortOnboarding: isForceShortOnboarding,
      gift: isGift,
      isRetailCustomer,
      isShortRegistrationFlow,
      product,
      subscription: isSubscription,
      team,
      ticketsorderhome: isTicketsOrderHome,
      validateticketonline: isValidateTicketOnline,
      weeks
    };

    const isAllUndefinedExtraParams = checkAllParamsUndefined(extraParams);
    if (!isAllUndefinedExtraParams) {
      theme = onboardingTheme.getTheme(branding);
      extraParams = _objectSpread(_objectSpread({}, extraParams), {}, {
        theme
      });
      await setExtraData({
        extraParams,
        req
      });
    } else {
      const sessionExtraParams = await getExtraData(req);
      if (sessionExtraParams) {
        theme = (sessionExtraParams === null || sessionExtraParams === void 0 ? void 0 : sessionExtraParams.theme) || onboardingTheme.getTheme();
      } else {
        theme = onboardingTheme.getTheme();
      }
      extraParams = _objectSpread(_objectSpread({}, extraParams), {}, {
        theme
      });
    }
  }
  return extraParams;
};
const exportFunctions = {
  setupExtraData,
  getExtraData,
  setExtraData,
  updateExtraData,
  clearExtraData
};

if (isServer) {
  module.exports = exportFunctions;
} else {
  svs.accountservices.onboardingHandler = _objectSpread(_objectSpread({}, svs.accountservices.onboardingHandler), exportFunctions);
}

 })(window);